export const loginUser = () =>{
    return process.env.REACT_APP_URL+'login';
}

export const logoutUser = () =>{
    return process.env.REACT_APP_URL+'logout';
}

export const getUser = (id) =>{
    return process.env.REACT_APP_URL+'users/'+id;
}

export const getUserErrorLog = (id) =>{
    return process.env.REACT_APP_URL+'errorLog/'+id;
}

export const createSucceededTransaction = (user_id) =>{
    return process.env.REACT_APP_URL+'createSucceededTransaction/'+user_id;
}

export const createFailedTransaction = (user_id) =>{
    return process.env.REACT_APP_URL+'createFailedTransaction/'+user_id;
}

export const createUser = () =>{
    return process.env.REACT_APP_URL+'createUser';
}

export const addNewUser = () =>{
    return process.env.REACT_APP_URL+'addNewUser';
}

export const deleteUser = (user_id) =>{
    return process.env.REACT_APP_URL+'deleteUser/'+user_id;
}

export const forgotPasswordOtpGenerate = () =>{
    return process.env.REACT_APP_URL+'generateForgotPasswordOtp';
}

export const forgotPasswordOtpVerify = () =>{
    return process.env.REACT_APP_URL+'verifyForgotPasswordOtp';
}

export const updateForgotPassword = () =>{
    return process.env.REACT_APP_URL+'updateForgotPassword';
}

export const changePassword = () =>{
    return process.env.REACT_APP_URL+'changePassword';
}

export const updateUser = (user_id) =>{
    return process.env.REACT_APP_URL+'updateUser/'+user_id;
}

export const getUserPointsTransactions = (user_id) => {
    return process.env.REACT_APP_URL+'userPointsTransactions/'+user_id;
}

export const getAllUsers = (users) => {
    return process.env.REACT_APP_URL+'users';
}

export const sendNotificationToUsers = () => {
    return process.env.REACT_APP_URL+'sendNotificationToUsers';
}

export const deactivateUser = (user_id) =>{
    return process.env.REACT_APP_URL+'deactivateUser/'+user_id;
}

export const reactivateUser = (user_id) =>{
    return process.env.REACT_APP_URL+'reactivateUser/'+user_id;
}

export const adminChangesUserPassword = (user_id) =>{
    return process.env.REACT_APP_URL+'adminChangeUserPassword/'+user_id;
}

export const adminResetsUserPassword = (user_id) =>{
    return process.env.REACT_APP_URL+'adminResetsUserPassword/'+user_id;
}

export const editInstitution = (institution_id) =>{
    return process.env.REACT_APP_URL+'updateInstitution/'+institution_id;
}

export const addLicense = () => {
    return process.env.REACT_APP_URL+'addLicense';
}

export const addInstitution = () => {
    return process.env.REACT_APP_URL+'addInstitution';
}

export const getLicenseInstitutionUsers = () => {
    return process.env.REACT_APP_URL+'getLicenseInstitutionUsers';
}

export const updateLicense = (license_id) =>{
    return process.env.REACT_APP_URL+'updateLicense/'+license_id;
}

export const getListNotifications = () => {
    return process.env.REACT_APP_URL+'listNotifications';
}

export const updateNotification = (notification_id) =>{
    return process.env.REACT_APP_URL+'updateNotification/'+notification_id;
}

export const getNotificationCount = (user_id) =>{
    return process.env.REACT_APP_URL+'notificationCount/'+user_id;
}

export const createMembership = () =>{
    return process.env.REACT_APP_URL+'membership';
}

export const getMemberships = () =>{
    return process.env.REACT_APP_URL+'membershipList';
}

export const updateMembership = (membership_id) =>{
    return process.env.REACT_APP_URL+'membership/'+membership_id;
}

export const applyMembership = () =>{
    return process.env.REACT_APP_URL+'applyMembership';
}

export const getMyMembership = () =>{
    return process.env.REACT_APP_URL+'myMembership';
}

export const requestMembershipCode = () =>{
    return process.env.REACT_APP_URL+'requestMembershipCode';
}